import JwtDecode from 'jwt-decode';
import Cookies from 'js-cookie';
import { CognitoUser } from '../store/user/user.types';
import { getCurrentLocale } from './utils.service';

class AuthService {
  authHeader = (refresh = true): HeadersInit => {
    if (refresh) this.tryToRefreshToken();
    const token = Cookies.get('token', {
      domain: process.env.REACT_APP_COOKIES_DOMAIN,
    });
    if (token) {
      return {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      };
    } else {
      return {};
    }
  };

  getCurrentUser() {
    const userData: CognitoUser = JSON.parse(
      Cookies.get('user', { domain: process.env.REACT_APP_COOKIES_DOMAIN })!
    );
    return userData;
  }

  isAuthenticated = (): boolean => {
    return (
      !!Cookies.get('token', {
        domain: process.env.REACT_APP_COOKIES_DOMAIN,
      }) &&
      !this.isTokenExpired(
        Cookies.get('token', { domain: process.env.REACT_APP_COOKIES_DOMAIN })
      )
    );
  };

  cleanStorage = (): void => {
    Cookies.remove('token', { domain: process.env.REACT_APP_COOKIES_DOMAIN });
    Cookies.remove('user', { domain: process.env.REACT_APP_COOKIES_DOMAIN });
    Cookies.remove('node', { domain: process.env.REACT_APP_COOKIES_DOMAIN });
    Cookies.remove('refreshToken', {
      domain: process.env.REACT_APP_COOKIES_DOMAIN,
    });
    localStorage.clear();
  };

  getToken = (): string | null => {
    return Cookies.get('token', {
      domain: process.env.REACT_APP_COOKIES_DOMAIN,
    });
  };

  tryToRefreshToken = async () => {
    try {
      const token: any = this.getToken();
      if (!!token) {
        const decoded: any = JwtDecode(token);
        const date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        const diff = (Date.now() - date.getTime()) / 1000 / 60;
        const minute = Math.abs(Math.round(diff));
        if (minute < 10) {
          const resp: any = await fetch(
            `${process.env.REACT_APP_API_HOST}/users/refresh_token`,
            {
              method: 'POST',
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
            }
          );
          const respJson = await resp.json();
          Cookies.set('token', respJson.data, {
            domain: process.env.REACT_APP_COOKIES_DOMAIN,
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  async loginSucessfull(): Promise<any> {
    const response = await fetch(
      `${process.env.REACT_APP_API_HOST}/internal/users/loginSucessfull`,
      {
        method: 'POST',
        headers: authService.authHeader(),
      }
    );
    return response;
  }

  getTokenDecode() {
    const token = this.getToken() || '';
    return JwtDecode(token);
  }

  isTokenExpired = (token: any) => {
    try {
      const decoded: any = JwtDecode(token);
      if (decoded.exp < Date.now() / 1000) {
        // Token is expired
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.log('expired check failed!: AuthService');
      return false;
    }
  };

  getQueryParams = (): any => {
    const query = decodeURIComponent(window.location.search);
    if (!!query) {
      const queryParam = query.slice(1).split('&');
      const entries = queryParam.map((param) => {
        const rep = param.split('=');
        if (rep.length > 2 && param.startsWith('callback=')) {
          // it is using when the url is like this: http://myurl?callback=http://domian?param=value
          return ['callback', param.split('callback=')[1]];
        }
        return rep;
      });
      const params = Object.fromEntries(entries);
      return params;
    }
    return {};
  };

  getRedirectUrls = (): string | undefined => {
    const urlsAllowed = [
      process.env.REACT_APP_CONTAINER_HOST,
      process.env.REACT_APP_USERS_HOST,
      process.env.REACT_APP_TICKETS_HOST,
      process.env.REACT_APP_CORE_HOST,
    ];
    console.log(this.getQueryParams());
    const callback: string = this.getQueryParams().callback;
    if (
      callback &&
      callback.match(
        '(' +
          urlsAllowed[0] +
          '|' +
          urlsAllowed[1] +
          '|' +
          urlsAllowed[2] +
          '|' +
          urlsAllowed[3] +
          ').*'
      )
    ) {
      return callback;
    }
  };

  getRedirectMessage = (): string | undefined => {
    const e = this.getQueryParams().e;
    switch (e) {
      case 'expired':
        if (getCurrentLocale() === 'es') {
          return 'Su sesión ha sido cerrada por inactividad. Por favor, ingrese de nuevo.';
        } else {
          return 'Your session has been closed due to inactivity. Please log in again';
        }
      case 'unauth':
        if (getCurrentLocale() === 'es') {
          return 'No tenes permisos para este sistema. Se ha cerrado su sesión.';
        } else {
          return 'You do not have permissions for this system. Your session has been closed';
        }
      case 'unrec':
        if (getCurrentLocale() === 'es') {
          return 'Sus permisos no son reconocidos por el sistema. Se ha cerrado su sesión.';
        } else {
          return 'Your permissions are not recognized by the system. Your session has been closed';
        }
      default:
        if (e) {
          console.log(`ErrorCode '${e}' no found`);
        }
        break;
    }
  };
}

const authService = new AuthService();
export default authService;
